import { API_ENTRYPOINT_URI, FILE_SYSTEM_MAPPER_ENTRYPOINT, FILE_SYSTEM_MAPPER_ENTRYPOINT_URI } from '@/utils/CONST';

export const composeUri = (resource: string, id?: string) => `/${API_ENTRYPOINT_URI}/${resource}/${id ?? ''}`;

export const composeMediaFmDownloadUrl = (mediaId: string, token: string) =>
    `${FILE_SYSTEM_MAPPER_ENTRYPOINT}/${FILE_SYSTEM_MAPPER_ENTRYPOINT_URI}/smartConnectView/file_system_mappers/${mediaId}/media/download.json?bearer=${token}`;
